module.exports = __webpack_public_path__ + "static/media/mongodb.1fdd34ef.png";